<div class="flex min-h-screen overflow-x-hidden">
  @if (sharedSrv.showNav && sharedSrv.user && !sharedSrv.site?.config?.asContentProvider) {
    <div
      id="fuulea-nav-bar"
      class="w-[72px] bg-[#181F30] text-white flex-shrink-0 fixed top-0 left-0 h-screen"
      style="z-index: 100"
    >
      <div class="px-[6px] h-full">
        <lib-fl-side
          [topContent]="logoContent"
          [menuItems]="menuItems"
          [bottomMenuItems]="bottomMenuItems"
          [selectedKey]="isMessageDrawerOpen ? 'message' : undefined"
        >
          <ng-template #logoContent>
            <div nz-row nzJustify="center" class="logo-box">
              <div class="logo" nz-row nzAlign="middle" nzJustify="center">
                <img style="width: 100%" nz-image nzDisablePreview [nzSrc]="logo | imageTransform: 'webp'" alt="" />
              </div>
            </div>
          </ng-template>
        </lib-fl-side>
      </div>
    </div>
  }

  <div
    class="flex-grow flex flex-col bg-[#F5F6F7] overflow-hidden relative"
    [ngClass]="{ 'ml-[72px]': sharedSrv.showNav && sharedSrv.user && !sharedSrv.site?.config?.asContentProvider }"
  >
    <nz-content>
      @if (baseLayoutService.showBasket && selectQuestionCount > 0 && !isPublishTaskRoute) {
        <div
          class="fixed-basket"
          libDraggableSnap
          [lockAxis]="DraggableSnapLockAxis.X"
          (click)="questionHandleSrv.goCheckQuestion('/exercise/publish/task')"
        >
          <i nz-icon nzType="shopping" nzTheme="outline"></i>
          @if (!showDashboard()) {
            <div class="badge">{{ selectQuestionCount }}</div>
          }
        </div>
      }
      @if (sharedSrv.isChrome90()) {
        <nz-alert
          [class.p-md]="showAlert"
          nzType="warning"
          nzCloseable
          [nzMessage]="alertContent"
          (nzOnClose)="closeAlert()"
        ></nz-alert>
      }
      <ng-template #alertContent>
        您的浏览器版本过低，可能导致部分功能异常，请更新或安装新的浏览器。点击<a
          target="_blank"
          href="https://www.microsoft.com/zh-cn/edge/download"
          >下载</a
        >最新版浏览器。
      </ng-template>
      <router-outlet></router-outlet>
    </nz-content>

    @if (isMessageDrawerOpen) {
      <fl-message-panel
        [hasSidebar]="sharedSrv.showNav && sharedSrv.user && !sharedSrv.site?.config?.asContentProvider"
        (close)="isMessageDrawerOpen = false"
      ></fl-message-panel>
    }
  </div>
</div>
